window.addEventListener('load', (event) => {
    if(window.innerWidth > 500){
        waitForSource();
    }else{
      waitForSource2()
    }
});

function waitForSource(){
    setTimeout(function(){
        const source = document.querySelector('.locale-selectors__container');
        if (!source) {
            waitForSource();
        }else{
            const destination = document.querySelector('.no-js-hidden');
            destination.append(source);
        }
    }, 350); 
}

function waitForSource2(){
      setTimeout(function(){
        const source = document.querySelector('.locale-selectors__container');
        if (!source) {
            waitForSource2();
        }else{
            const destination = document.querySelector('.social-links')
            destination.append(source);
        }
    }, 550); 
}
